import { Spinner } from "@blueprintjs/core";
import * as React from "react";
import { useParams } from "react-router";

import {
  DrupalWorkbookRequestDto,
  EPlatform,
  ERequestState,
  RequestDto,
  WorkbookRequestApi,
  WorkbookRequestDto,
} from "../../../../api";
import { PageContainer } from "../../../../components";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalRequestResume, DrupalStepper } from "../../../common";
import { DrupalFieldSet } from "../../../common/DurpalFieldSet";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalWorkbookForm } from "./DrupalWorkbookForm";

export interface IDrupalWorkbookRequestPageProps {}

export const DrupalWorkbookRequestPage: React.FunctionComponent<IDrupalWorkbookRequestPageProps> = () => {
  const { id } = useParams<{ id: string }>();
  const workbookrequestId = React.useMemo(() => +id, [id]);
  const api = useApiService(WorkbookRequestApi);
  const { t } = useTl();
  const [files, setFiles] = React.useState<any[]>([]);

  const [currentStep, setCurrentStep] = React.useState(0);

  // TODO: Files => Create save callback as in DrupalTitleRequestPage.tsx

  const { data, loading, saveItem, saving } = useCrudApi<DrupalWorkbookRequestDto>(
    React.useMemo(
      () => ({
        getApiFn: (apiId = workbookrequestId) =>
          apiId > 0
            ? api.getDrupalWorkbookRequest(apiId)
            : new DrupalWorkbookRequestDto({
                transientWorkbooksGridDtos: [],
                request: new RequestDto({
                  requestDate: new Date(),
                  status: ERequestState.REQUESTED,
                  platform: EPlatform.PORTAL,
                }),
              }).toJSON(),
        saveApiFn: async (d: any) => {
          var workbookRequestId = await api.saveDrupalWorkbookRequest(d);
          await d?.files?.map(
            async (f) =>
              await api.saveRequestFiles(
                workbookRequestId,
                d.files?.map((f) => ({ data: f.file, fileName: f.filename }))
              )
          );
          return workbookRequestId;
        },
        onSavedRoute: (d) =>
          d.request.status === ERequestState.BILLED
            ? `${EDrupalRoutes.workbookRequest}/${d.workbookRequestId}`
            : EDrupalRoutes.requestList,
        deleteApiFn: () => {},
      }),
      [api, workbookrequestId]
    ),
    [workbookrequestId]
  );

  return loading ? (
    <Spinner />
  ) : (
    <PageContainer>
      <DrupalFieldSet
        title={
          currentStep === 2
            ? `${t(ETLCodes.Payment)}: ${t(ETLCodes.WorkbookRequest)}`
            : `${t(ETLCodes.NewRequest)}: ${t(ETLCodes.WorkbookRequest)}`
        }
      >
        {data.request.status === ERequestState.REQUESTED ? <DrupalStepper stepNumber={currentStep} /> : null}
        <div>
          {data.request.status === ERequestState.REQUESTED && currentStep !== 2 ? (
            <DrupalWorkbookForm
              workbookRequestId={workbookrequestId}
              stepNumber={currentStep}
              initialdata={data}
              loading={saving}
              onStepChange={(newStep) => setCurrentStep(newStep)}
              save={(formikdata) => saveItem(formikdata)}
              files={files}
              setFiles={setFiles}
            />
          ) : saving ? (
            <Spinner />
          ) : (
            <>
              <DrupalRequestResume
                requestForm={
                  <DrupalWorkbookForm
                    showStepper={data?.request?.status !== ERequestState.BILLED}
                    workbookRequestId={workbookrequestId}
                    stepNumber={currentStep}
                    initialdata={data}
                    loading={saving}
                    onStepChange={(newStep) => setCurrentStep(newStep)}
                    save={(formikdata) => saveItem(formikdata)}
                    files={files}
                    setFiles={setFiles}
                  />
                }
                requestDto={data?.request}
                bill={null}
              />
            </>
          )}
        </div>
      </DrupalFieldSet>
    </PageContainer>
  );
};
